import {
  getCollectionId,
  getCountry,
  getCurrency,
  getCurrencyRate,
  getCompanyId,
  getCompanyLocationId,
  getCustomerId,
  getLocale,
  getPageId,
  getPageType,
  getRootRoute,
  getCustomerTags,
  getCartUrls,
} from './helpers.ts';

const currentPageType = getPageType();
const currentCollectionId = getCollectionId();
const currentPageId = getPageId();
const rootRoute = getRootRoute();
const { add } = getCartUrls();

// 4: https://store.myshopify.com/en/collections/maintenance-tools/tag
// 3: https://store.myshopify.com/collections/maintenance-tools/tag
const referrerPosition = rootRoute ? 4 : 3;
const isReferrerInUrl =
  currentPageType === 'collection' &&
  window.location.pathname.split('/').filter(Boolean).length >= referrerPosition;

const urlQueryParam = new URLSearchParams(window.location.search).get('q');

const pageTypeToPreselectionMap = {
  category: currentCollectionId ? [{ field: 'collection_ids', term: `${currentCollectionId}` }] : [],
  brand: urlQueryParam ? [{ field: 'vendor', term: urlQueryParam }] : [],
};

function getLocalPreselection(pageType) {
  return pageTypeToPreselectionMap[pageType] || null;
}

function collectExtra() {
  const extra = {};

  if (rootRoute) {
    extra.platformRoute = rootRoute;
  }

  if (currentPageType === 'page') {
    extra.pageId = currentPageId;
  }

  const country = getCountry();
  if (country) {
    extra.country = country.toLowerCase();
  }

  const currency = getCurrency();
  if (currency) {
    extra.currency = currency.toLowerCase();
  }

  const currencyRate = getCurrencyRate();
  if (currencyRate) {
    extra.currencyRate = currencyRate;
  }

  const locale = getLocale();
  if (locale) {
    extra.locale = locale;
  }

  const companyId = getCompanyId();
  if (companyId) {
    extra.customerCompanyId = companyId;
  }

  const companyLocationId = getCompanyLocationId();
  if (companyLocationId) {
    extra.customerCompanyLocationId = companyLocationId;
  }

  const customerTags = getCustomerTags();
  if (customerTags?.length) {
    extra.customerTags = customerTags;
  }

  return extra;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getSearchRequestDefaults(pageType) {
  const requestDefaults = {};

  if (isReferrerInUrl) {
    requestDefaults.referrer = encodeURIComponent(window.location.pathname);
  }

  requestDefaults.extra = collectExtra();

  return requestDefaults;
}

function getAutocompleteRequestDefaults() {
  return collectExtra();
}

async function ajaxAddToCart(id, quantity = 1) {
  const formData = { items: [{ id, quantity }] };

  return fetch(`${add}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });
}

async function addItemsToCart(ids) {
  for (const id of ids) {
    await ajaxAddToCart(id);
  }
}

getLocalPreselection.defaults = { getter: getLocalPreselection };

async function getCustomerAsync() {
  const id = getCustomerId();
  window.Convermax.customerId = id;
  window.Convermax.isLoggedIn = !!id;
  return id ? { id } : null;
}

export default {
  getLocalPreselection,
  getSearchRequestDefaults,
  addItemsToCart,
  getAutocompleteRequestDefaults,
  getCustomerAsync,
  isReferrerInUrl,
  platformRoute: rootRoute,
};
